import { Chip } from "@mui/material";
import { getChangelogTypeMeta } from "utils/changelogService";
import { formatDisplayDate } from "utils/dateFormat";

const BRANCH_LABEL = {
  main: "Live",
  staging: "Staging preview",
};

const ChangelogEntryList = ({ entries = [], emptyMessage = "Nothing to show yet." }) => {
  if (!entries.length) {
    return <p className="text-sm text-app-text-muted text-center py-6">{emptyMessage}</p>;
  }

  return (
    <div className="space-y-6">
      {entries.map((entry) => (
        <div key={entry.id} className="relative">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-semibold text-app-text">
              {formatDisplayDate(entry.date)}
            </span>
            <Chip
              size="small"
              label={BRANCH_LABEL[entry.branch] || entry.branch}
              color={entry.branch === "main" ? "success" : "default"}
              variant="outlined"
              sx={{ height: 20, fontSize: 11 }}
            />
          </div>
          <ul className="space-y-2 pl-1">
            {(entry.items || []).map((item, idx) => {
              const meta = getChangelogTypeMeta(item.type);
              return (
                <li key={idx} className="flex items-start gap-2">
                  <span
                    className={`shrink-0 mt-0.5 rounded-full px-2 py-0.5 text-[11px] font-semibold capitalize ${meta.className}`}
                  >
                    {meta.label}
                  </span>
                  <span className="text-sm text-app-text">{item.message}</span>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default ChangelogEntryList;
